module.exports = __webpack_public_path__ + "media/images/post-job-dc68946946b6f64f5fb344d322c8e074.svg";